import React, { useRef } from 'react';
import { createRoot } from 'react-dom/client';
import stringUtils from '../../utils/string.utils';

const SearchBox = () => {
    const keywordRef = useRef();

    const onSubmit = (e) => {
        if (stringUtils.isNullOrEmpty(keywordRef.current.value)) {
            e.preventDefault();
        }
    };
    return (
        <>
            <div
                className="search dropdown"
                data-toggle="modal"
                data-target=".bs-example-modal-lg"
            >
                <i className="icon"></i>
            </div>
            <div
                className="modal fade bs-example-modal-lg"
                tabIndex="-1"
                role="dialog"
                aria-hidden="true"
                style={{ display: 'none' }}
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content popup-search">
                        <button
                            type="button"
                            className="close"
                            data-dismiss="modal"
                        >
                            <i className="fa fa-times" aria-hidden="true"></i>
                        </button>
                        <div className="modal-body">
                            <form
                                action="/tim-kiem/san-pham"
                                method="get"
                                onSubmit={onSubmit}
                            >
                                <div className="input-group">
                                    <input
                                        type="text"
                                        ref={keywordRef}
                                        className="form-control control-search"
                                        placeholder="Search and hit enter..."
                                        name="keyword"
                                    />
                                    <button
                                        className="button_search"
                                        type="submit"
                                    >
                                        Search
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

SearchBox.propTypes = {};

export default SearchBox;

document.querySelectorAll('react-search-box').forEach((domContainer) => {
    const root = createRoot(domContainer);
    root.render(<SearchBox />);
});
